export default __webpack_public_path__ + "static/media/hero-about.3a802a21.jpg";